import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

// Simple version with any typing to solve the non-portable type issue
type StylesHook = () => { classes: any; cx: any };

// Define the styles
const useStyles = makeStyles<void>()((theme: Theme) => ({
  fullWidth: {
    width: '100%',
  },

  shortWidth: {
    maxWidth: '250px',
    width: '100%',
  },
  shortSpace: {
    '& .MuiInputBase-input ': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },
  inputField: {
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      backgroundColor: '#F5F6FA',
      borderColor: '#BFBFBF',
    },
    '& .MuiMenuItem-root': {
      [theme.breakpoints.down(1520)]: {
        fontSize: '14px',
      },
    },
    '& .Mui-disabled': {
      backgroundColor: '#fff',
      color: '#BFBFBF',
      fontWeight: '400',
      borderColor: '#E8E8E8',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#E8E8E8',
      },
    },
  },
}));

// Export with type annotation
export const useFieldMaterialUIStyles: StylesHook = () => useStyles();
